export enum SortingOrders {
  'ASC' = 'ASC',
  'DESC' = 'DESC'
}
